import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, Typography, DialogContent, DialogActions, Button, Box, useMediaQuery, useTheme, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { between } from "@ui/style/style";
export const ConfirmDeleteExternalDialog = ({ isOpen, onClose, onConfirm, title, bodyText }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    return (_jsxs(Dialog, { open: isOpen, onClose: onClose, maxWidth: "sm", "aria-labelledby": "ConfirmDeleteExternalInviteDialog", onKeyDown: (e) => e.key === "Enter" && onConfirm && onConfirm(), PaperProps: {
            sx: {
                width: "592px",
            },
        }, children: [_jsx(DialogTitle, { sx: { ...between, pb: 1 }, id: "ConfirmDeleteExternalInviteDialog", children: title && (_jsx(Typography, { fontFamily: "SuisseIntl", variant: "h5", fontWeight: 500, color: "#00244D", children: title })) }), _jsx(DialogContent, { children: _jsx(Box, { children: _jsx(Typography, { variant: "body1", color: "#00244D", children: bodyText }) }) }), _jsxs(DialogActions, { sx: {
                    pb: 2,
                    px: 3,
                    flexDirection: {
                        xs: "column-reverse",
                        sm: "column-reverse",
                        md: "row",
                    },
                    gap: 1,
                }, children: [_jsx(Button, { sx: {
                            marginLeft: "0 !important",
                            fontWeight: 400,
                        }, onClick: onClose, color: "inherit", variant: "contained", fullWidth: true, children: t("admin.familyFest.keepInvitation") }), _jsx(Button, { sx: {
                            marginLeft: "0 !important",
                            fontWeight: 400,
                        }, onClick: onConfirm, color: "error", variant: "contained", fullWidth: true, children: t("admin.familyFest.deleteInvitation") })] })] }));
};
